"use client";

import { Navbar } from "@/components/layout/Navbar";
import { StickyDonate } from "@/components/layout/StickyDonate";
import { MobileNavOpenProvider } from "@/components/layout/MobileNavOpenContext";

export function SiteLayoutClient() {
  return (
    <MobileNavOpenProvider>
      <Navbar />
      <StickyDonate />
    </MobileNavOpenProvider>
  );
}
